export default {
    methods: {
        outletRemote(query) {
            return this.getOutletListIfNecessary({ query }).then(data => {
                return data.map(o => ({
                    id: o.id,
                    display_name: o.name,
                }));
            });
        },

        regionRemote(query) {
            return this.getRegionListIfNecessary({ query }).then(data => {
                return data.map(o => ({
                    id: o.id,
                    display_name: o.name,
                }));
            });
        },

        siteIdRemote(query) {
            return this.getOutletListIfNecessary({ query }).then(data => {
                return data.map(o => ({
                    id: o.code,
                    display_name: o.code,
                }));
            });
        },

        stateRemote(query) {
            return this.getStateListIfNecessary({ query }).then(data => {
                return data.map(name => ({
                    id: name,
                    display_name: name,
                }));
            });
        },

        tierRemote(query) {
            return this.getTierListIfNecessary({ query }).then(data => {
                return data.map(o => ({
                    id: o.id,
                    display_name: o.name,
                }));
            });
        },

        categorysRemote() {
            return this.getCategoriesListIfNecessary().then(data => {
                return data.map(o => ({
                    id: o.id,
                    display_name: o.name,
                }));
            });
        },

        tagsRemote() {
            return this.getParentTagListIfNecessary().then(data => {
                return data.map(o => ({
                    id: o.id,
                    display_name: o.name,
                }));
            });
        },
    },
};
